import axios from "axios";
import {
  DAILY_STATUS_REQUEST,
  DAILY_STATUS_SUCCESS,
  DAILY_STATUS_FAIL
} from "../constants/dailyStatusConstants"

export const getDailyStatus = (userId) => async (dispatch, getState) =>{
   try {
    dispatch({
        type: DAILY_STATUS_REQUEST,
    });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
  
      const { data } = await axios.get(
       `/api/users/${userId}/dailystatus`,
        config
      );
  
      dispatch({
        type: DAILY_STATUS_SUCCESS,
        payload: data,
      });

   } catch (error) {
    dispatch({
      type: DAILY_STATUS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }

}